<template>
  <div class="settings-roles settings-templates">
    <EditRoleTemplateDialog
      :bookingTemplate="currentBookingTemplate"
      @close="closeDialog"
      :isOpen="isOpen"
    />
    <div class="container col-lg-8 col-sm-12 mb-12">
      <BaseListToolbar title="Role Templates" @search="updateSearchValue" />
      <div v-if="isFetchingOrganisationBookingTemplates">
        <v-skeleton-loader v-for="i in 5" :key="i" s type="list-item-avatar" />
      </div>
      <div v-else>
        <v-list-item
          v-for="bookingTemplate in bookingTemplates"
          :key="bookingTemplate.id"
          @click="handleSelect(bookingTemplate)"
        >
          <RoleListItem :bookingTemplate="bookingTemplate" />
        </v-list-item>
      </div>
      <v-pagination
        :total-visible="page.pageSize"
        v-if="showPagination"
        v-model="page.currentPage"
        @input="loadBookingTemplates"
        :length="page.lastPage"
      />
      <BaseFooter>
        <NewRoleAction @created="loadBookingTemplates" />
      </BaseFooter>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { ORGANISATION_BOOKING_TEMPLATES_NAMESPACE } from "@/store/modules/organisations/organisation-booking-templates";
import { FETCH_ORGANISATION_BOOKING_TEMPLATES } from "@/store/modules/organisations/organisation-booking-templates/actions";
import { copyState } from "@/utils/helpers";
import RoleListItem from "@/views/settings/components/role-templates/components/RoleListItem";
import BaseFooter from "@/components/common/BaseFooter";
import NewRoleAction from "@/views/settings/components/role-templates/components/actions/NewRoleAction";
import EditRoleTemplateDialog from "@/views/settings/components/role-templates/components/dialogs/EditRoleTemplateDialog";
import BaseListToolbar from "@/components/common/Toolbar/BaseListToolbar";
import { map, size } from "lodash";
import { paginationMixin } from "@/mixins/pagination.mixin";

const { mapActions, mapState } = createNamespacedHelpers(
  ORGANISATION_BOOKING_TEMPLATES_NAMESPACE
);

export default {
  name: "Roles",
  mixins: [paginationMixin],
  components: {
    RoleListItem,
    BaseFooter,
    NewRoleAction,
    EditRoleTemplateDialog,
    BaseListToolbar
  },
  created() {
    this.loadBookingTemplates();
  },
  data() {
    return {
      isOpen: false,
      currentBookingTemplate: {},
      searchText: ""
    };
  },
  computed: {
    ...mapState(
      copyState([
        "organisationBookingTemplates",
        "isFetchingOrganisationBookingTemplates"
      ])
    ),
    bookingTemplates() {
      return map(this.organisationBookingTemplates, template => {
        const functionName = template.function && template.function.name;
        return { ...template, functionName };
      });
    },
    requestParams() {
      return {
        filter: {
          ...(size(this.searchText) && { jobTitle: this.searchText })
        },
        ...this.requestPageParams
      };
    }
  },
  methods: {
    ...mapActions({
      fetchBookingTemplates: FETCH_ORGANISATION_BOOKING_TEMPLATES
    }),
    async loadBookingTemplates() {
      const data = await this.fetchBookingTemplates(this.requestParams);
      if (data) {
        this.updatePageDetails(data.meta);
      }
    },
    handleSelect(template) {
      this.currentBookingTemplate = template;
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    },
    updateSearchValue(text) {
      this.searchText = text;
      this.resetPagination();
      this.loadBookingTemplates();
    }
  }
};
</script>

<style lang="scss">
.settings-roles {
  position: relative;
}
</style>
